/* eslint-disable import/no-anonymous-default-export */
/*
 * Cookie
 */
export default {
  read: function (name) {
    var value = document.cookie.match("(?:^|;)\\s*" + name + "=([^;]*)");
    return value ? decodeURIComponent(value[1]) : null;
  },
  write: function (name, v, value = {}) {
    var str = name + "=" + encodeURIComponent(v);
    if (value.domain) {
      str += "; domain=" + value.domain;
    } else {
      str +=
        "; domain=." +
        window.location.hostname.replace(
          window.location.hostname.split(".").shift() + ".",
          ""
        );
    }
    str += "; path=" + (value.path || "/");
    if (value.day) {
      var time = new Date();
      time.setTime(time.getTime() + value.day * 24 * 60 * 60 * 1000);
      str += "; expires=" + time.toUTCString();
    }
    if (value.expires) {
      str += "; expires=" + value.expires.toUTCString();
    }
    document.cookie = str;
    return;
  },
  del: function (name, options) {
    var opt = options || {};
    if (!opt.domain) {
      opt.domain = '.' + window.location.hostname.replace(
        window.location.hostname.split(".").shift() + ".",
        ""
      );
    }
    opt.path = opt.path || "/";
    opt.day = -1;
    this.write(name, "", opt);
    return;
  },
};
